// extracted by mini-css-extract-plugin
module.exports = {"paginado":"Paginado2_paginado__2Q0S9","btn":"Paginado2_btn__QXah1","PaginadoInput":"Paginado2_PaginadoInput__dizNo","divPaginado2":"Paginado2_divPaginado2__DlBuu"};